module.exports = __webpack_public_path__ + "img/gift2-04-c1.897d2df7.png";